// @ts-check
import React from "react"
import { useSession } from "../../hooks/auth/useSession.hook"
import { ROLES_TO_SHOW } from "../../consts/roles.consts"
import useThemeContext from "../../hooks/contextConsumers/useThemeContext.hook"
import useSidebarContext from "../../hooks/contextConsumers/useSidebarContext.hook"
import { THEME_MODES } from "../../consts/themes.consts"
import { clsx } from "../../utils/strings.utils"
import OpenInNew from "@mui/icons-material/OpenInNew"
import { EXTERNAL_LINKS } from "../../consts/externalLinks.consts"
import ClockCDMX from "../../components/compounds/ClockCDMX.compound"

const AppMenuUserPreview = ({
  closeMobileOverlay = () => {},
  showLogoutModal = () => {},
}) => {
  const { user } = useSession()
  const { setSidebarActive } = useSidebarContext()
  const { changeTheme, theme } = useThemeContext()
  const isDarkTheme = theme === THEME_MODES.DARK

  return (
    <div className="user-info-sidebar flex flex-column ">
      <a>
        <div
          className={`user-info ${user.isAdmin() ? "user-info--admin" : ""} flex align-items-center gap-2`}
        >
          <div className="flex align-items-center">
            <span className="user-tag border-circle flex align-items-center justify-content-center lg:text-xs font-bold my-auto">
              {user?.nameTag}
            </span>
          </div>
          <div className="flex flex-column">
            <span className="user-name flex align-items-center">
              {user?.nombre?.split(" ")[0]}
            </span>
            <span className="user-role flex align-items-center">
              {ROLES_TO_SHOW[user.projectRole]}
            </span>
          </div>
        </div>
      </a>

      {user.isAdmin() && (
        <a href={EXTERNAL_LINKS.CAREERS_ADMIN} target="_blank" rel="noreferrer">
          <div className="user-info-sidebar-menu-item flex gap-2 align-items-center mt-0 lg:mt-4 cursor-pointer mb-0 lg:mb-1">
            <OpenInNew style={{ fontSize: "24px" }} />
            <span>Candidatos</span>
          </div>
        </a>
      )}
      <ClockCDMX />
      <div
        className="user-info-sidebar-menu-item flex gap-2 align-items-center mt-0 lg:mt-4 cursor-pointer mb-0 lg:mb-1"
        onClick={() => {
          changeTheme()
          setSidebarActive(false)
          closeMobileOverlay()
        }}
      >
        <i
          className={clsx(
            "pi pi-fw text-xl pr-1",
            isDarkTheme ? "pi-sun" : "pi-moon"
          )}
        ></i>
        <span>{isDarkTheme ? "Que se haga la luz" : "Ir al lado oscuro"}</span>
      </div>
      <div
        className="user-info-sidebar-menu-item logout-caller flex gap-2 align-items-center mt-0 lg:mt-4 cursor-pointer"
        onClick={() => {
          showLogoutModal()
          closeMobileOverlay()
        }}
      >
        <i className="pi pi-power-off text-xl pr-1"></i>
        <span>Cerrar sesión</span>
      </div>
    </div>
  )
}

export default AppMenuUserPreview
